const arrify = require('arrify')

const { pcClassIdBySubClassIdCollection } = require('./../constants/pcSubClassList')

module.exports = (pcSubClassId, pcClassIdToUse, otherParams = '') => {
  const pcClassId = pcClassIdToUse || arrify(pcClassIdBySubClassIdCollection[pcSubClassId])[0]

  return `/pc-class-catalog/${pcClassId}/${pcSubClassId}${otherParams}`
}
